import React from 'react';
import ReactDOM from 'react-dom';
import { useState } from 'react';

import './postAd.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import Pagination from 'react-bootstrap/Pagination';


import { HiOutlineArrowLongRight } from "react-icons/hi2";
import { IoCheckmarkDoneCircle } from "react-icons/io5";
import { useNavigate } from "react-router";



import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import AccountSidebar from '../../components/sidebar/accountSidebar';

import {connect} from 'react-redux';
import * as actions from '../../store/customer/actions';


let active = 2;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>,
  );
}

const PostSuccess = () => {    

    const navigate = useNavigate(); 

    return (
        <div>
            <Header/>            

            <section className='pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center'>
                        <AccountSidebar />
                        <Col lg={9}>
                            <div class="card shadow p-5 text-center">
                                <div className='iconBox'><IoCheckmarkDoneCircle /></div>
                                <h2>Your ad is successfully posted and under review</h2>
                                <p>Proin placerat risus non justo faucibus commodo. Nunc non neque sit amet magna aliquam condimentum.</p>
                                <div className='mt-4'>
                                    <Button variant="light" size="lg" onClick={()=> navigate(`/`)}>Go to Home</Button>
                                    <Button variant="info" size="lg" className="ms-3" onClick={()=> navigate(`/properties`)}>View Ads <HiOutlineArrowLongRight /></Button>
                                </div>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            
            <Footer/>
        </div>
    )
}
function mapStateToProps(state) {
    return {
      
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
          signUp: (post) => dispatch(actions.signUp(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(PostSuccess);
